import { motion, useScroll, useSpring } from "framer-motion";

/**
 * Pinned to the header's bottom edge (absolute), so it stays aligned
 * regardless of header shrink-on-scroll or announcement banner.
 */
const ScrollProgress = () => {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 120,
    damping: 28,
    mass: 0.4,
  });

  return (
    <motion.div
      aria-hidden
      style={{ scaleX, transformOrigin: "0% 50%" }}
      className="absolute left-0 right-0 bottom-0 h-px bg-primary pointer-events-none"
    />
  );
};

export default ScrollProgress;
